import * as actionTypes from '../actions/actionTypes';


export default function groupAdminReducer(state = {}, action) {
    switch(action.type){
      case actionTypes.SET_GROUP_ADMIN_DETAIL:
        return {
          ...state,
          ...action.data
        }
        
      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/groupAdminReducer.js